    var s = document.createElement('script');
    s.type = "text/javascript";
    s.src   = "https://momentjs.com/downloads/moment.min.js";
    document.getElementsByTagName('head')[0].appendChild(s);

    s.onload = function(e){
        var s1 = document.createElement('script');
        s1.type = "text/javascript";
        s1.src   = "https://momentjs.com/downloads/moment-timezone.min.js";
        document.getElementsByTagName('head')[0].appendChild(s1);

        s1.onload = function(e){
            var mom  = '';
            var cT   = '';
            var hrs  = '';
            var mins = '';
            var secs = '';
            var dayOfDate = '';
            var d = '';
            var msg = '';

            function chkTime(){
                moment.tz.add('America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6');
                mom  = moment(new Date());
                cT   = mom.tz('America/New_York').format();
                hrs  = mom.format('H');
                mins = mom.format('mm'); 
                secs = mom.format('ss');
                dayOfDate = mom.format('e');
                d = mom.format('ddd');
                //console.log(hrs+" "+mins+" "+secs+" "+dayOfDate+" "+d);
                if(dayOfDate == 0){//sunday
                    msg = "<strong>Est&nbsp;delivery</strong>: Tues - Thurs";
                }
                else if( ( dayOfDate == 5 && hrs > 14 ) || dayOfDate == 6 ){//Friday or Saturday
                    msg = "<strong>Est&nbsp;delivery</strong>: Tues - Thur";
                }
                else if( dayOfDate == 1 && hrs <= 14 ){//Monday before 3pm
                    msg = "<strong>Ships today</strong>, if ordered in the next <span>"+(14-hrs)+"&nbsp;hrs&nbsp;"+(60-mins)+"&nbsp;mins</span>.<br><strong>Est&nbsp;delivery</strong>: Tues - Thurs";
                }
                else{
                    if(hrs <= 14 && mins <= 59){//before 3PM
                        if(dayOfDate == 4 || dayOfDate == 5){//changed message for friday
                          msg = "<strong>Ships today</strong>, if ordered in the next <span>"+(14-hrs)+"&nbsp;hrs&nbsp;"+(60-mins)+"&nbsp;mins</span>.<br><strong>Est&nbsp;delivery</strong>: " +mom.tz('America/New_York').add(1,'day').format('ddd')+" - "+mom.tz('America/New_York').add(3,'days').format('ddd');
                        }
                        else{
                            msg = "<strong>Ships today</strong>, if ordered in the next <span>"+(14-hrs)+"&nbsp;hrs&nbsp;"+(60-mins)+"&nbsp;mins</span>.<br><strong>Est&nbsp;delivery</strong>: " + mom.tz('America/New_York').add(1,'day').format('ddd')+" - "+mom.tz('America/New_York').add(2,'days').format('ddd');
                        } 
                    }
                    else{//after 3PM
                        if( dayOfDate == 4 ){
                            msg = "<strong>Est&nbsp;delivery</strong>: "+ mom.tz('America/New_York').add(2,'days').format('ddd')+" - Tues";
                        }else if( dayOfDate == 3){
                            msg = "<strong>Est&nbsp;delivery</strong>: "+ mom.tz('America/New_York').add(2,'days').format('ddd')+" - "+mom.tz('America/New_York').add(3,'days').format('ddd');
                        }else{
                            msg = "<strong>Est&nbsp;delivery</strong>: "+ mom.tz('America/New_York').add(2,'days').format('ddd')+" - "+mom.tz('America/New_York').add(2,'days').format('ddd');
                        }
                    }
                }
                
                $('#custom_message, .custom_message').css('display','block').html('<span class="custom-shipping-message">'+msg+'</span><span class="info-ship"><img src="https://cdn.shopify.com/s/files/1/0700/5519/8950/files/info-msg.svg?v=1729838946" /></span><span class="popup-box-message"><p>We try to keep all products in stock at all of our warehouses, but sometimes we might be out of stock of a product in the warehouse nearest to you. In these instances, shipping times might take longer than 1-3 business days.</p><p>Thanks for your understanding.</p></span>'); 
            }
            $(function(){
              
              chkTime();
					setInterval(function(){
						chkTime();    
					},1000);
            });
        }
    }


setTimeout(function() { 
  $("a.Chat").attr("data-reamaze-lightbox", "contact");
  $('a.Meteor-Navigation__Link__desktop svg').parent('a').addClass('have-nav');
}, 5000); 

$(document).ready(function(e) {

$('.custom-select__option').on('click', function() {
  setTimeout(function() { 
  calculatereward();
   }, 1000);  
});

function calculatereward(){
  var defaultPrice = $('.price__default strong.price__current').text().replace('$', '').trim();
  //console.log(defaultPrice );
  // Convert the extracted price to a number
  var numericPrice = parseFloat(defaultPrice);
  //console.log(numericPrice);
  // Check if the extracted price is a valid number
  if (!isNaN(numericPrice)) {
    // Calculate 5% of the price
    var reward = (numericPrice * 0.05).toFixed(2); // Keep it to 2 decimal places
    $('#reward').text("$"+ reward);
  
    // Log the 5% reward value to the console
    //console.log("5% of the price is: $" + reward);
  } else {
    //console.log("Invalid price value");
  }
}

calculatereward();
  
});	

  setInterval(function() {
    // Check if <s> tag exists inside #CartsubTotal
    var cartSubTotalElement = $('#CartsubTotal');
    var subTotalPrice;

    if (cartSubTotalElement.find('s').length) {
        // Get the price not in the <s> tag
        subTotalPrice = cartSubTotalElement
            .clone() // Clone the element
            .children('s') // Remove the <s> tag and its content
            .remove()
            .end()
            .text()
            .trim();
    } else {
        // Use the full text if no <s> tag is present
        subTotalPrice = cartSubTotalElement.text().trim();
    }

    // Extract numeric value from the price text
    var subTotalPriceVal = parseFloat(subTotalPrice.replace('$', ''));

    // Calculate reward points
    var rewardPointsVal = (subTotalPriceVal / 100) * 5;
    var rewardPoints = rewardPointsVal.toFixed(2);

    console.log(rewardPoints);

    // Update the reward points value in the designated element
    $('.cart-reward #reward').text("$" + rewardPoints);
}, 500);

